<template>
  <span class="scriv-pro-tag px-3">PRO</span>
</template>

<script>
export default {
  name: 'ScrivProIcon'
}
</script>

<style lang="scss" scoped>

.scriv-pro-tag {
  background: #737373;
  color: #fff;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 100px;
  padding: 2px 0;
}

</style>
